import axios from 'axios';
import { getToken, clearSession } from './auth';

export const API_URL = 'https://api.nearits.in';

// Single axios instance for all authenticated calls. The request interceptor
// attaches the scoped web token as a Bearer header; the response interceptor
// drops the session and bounces to the QR login when the token is rejected.
const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearSession();
      if (window.location.pathname !== '/') {
        window.location.replace('/');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
